module.exports = __webpack_public_path__ + "img/car_1.6f6a79ff.png";